// Toggle controller for showing/hiding elements
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleable"]

  toggle() {
    this.toggleableTargets.forEach(target => {
      const willBeVisible = target.classList.contains("hidden")
      target.classList.toggle("hidden")
      
      // If the element is now visible, trigger any Stimulus controllers inside
      if (willBeVisible) {
        this.initializeNestedControllers(target)
      }
    })
  }

  show() {
    this.toggleableTargets.forEach(target => {
      target.classList.remove("hidden")
      this.initializeNestedControllers(target)
    })
  }
  
  // Helper to reinitialize nested Stimulus controllers when shown
  initializeNestedControllers(element) {
    // Trigger any schedule-builder controllers
    const scheduleBuilder = element.querySelector('[data-controller~="schedule-builder"]')
    if (scheduleBuilder) {
      const controller = this.application.getControllerForElementAndIdentifier(scheduleBuilder, 'schedule-builder')
      if (controller && controller.updateCronExpression) {
        setTimeout(() => {
          controller.toggleFields()
          controller.updateCronExpression()
        }, 50)
      }
    }
  }

  hide() {
    this.toggleableTargets.forEach(target => {
      target.classList.add("hidden")
    })
  }
}

